import { api } from '~/services/api'

export const searchFactoriesApi = (params) => {
  const uri = `/factories`
  return api.get(uri, params)
}
